export const requestPasswordResetEndpoint = "users/password-resets";

export const validatePasswordResetTokenEndpoint = (token: string) => `users/password-resets/${token}`;

